import { render } from "./UpdateCurrentRestaurant.vue?vue&type=template&id=06cc673c&scoped=true"
import script from "./UpdateCurrentRestaurant.vue?vue&type=script&lang=js"
export * from "./UpdateCurrentRestaurant.vue?vue&type=script&lang=js"

import "./UpdateCurrentRestaurant.vue?vue&type=style&index=0&id=06cc673c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cc673c"]])

export default __exports__